export const getSubjectTextClass = (subject, variant = 'light') => {
  return `text-subject-${subject}-${variant}`
}

export const getSubjectBorderClass = (subject, variant = 'light') => {
  return `border-subject-${subject}-${variant}`
}

export const getSubjectBackgroundClass = (subject, variant = 'light') => {
  return `bg-subject-${subject}-${variant}`
}
